import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import { createHead } from '@unhead/vue';

import './styles/main.css';

loadFonts()

const head = createHead();
const app = createApp(App)
  .use(vuetify)
  .use(router)

app.use(head);
app.mount('#app');


  